import React from "react";
import DefaultView from "../../layouts/content/DefaultView/DefaultView";
import SessionContainer from "../../components/SessionView/SessionContainer";
import Launchpad from "components/Launchpad/Launchpad";

function LaunchpadPage(props) {
  return (
    <DefaultView>
      <SessionContainer uri="/Workspace/Config/ConfigData" isPersistant={true} {...props}>
        <Launchpad {...props} />
      </SessionContainer>
    </DefaultView>
  );
}

export default LaunchpadPage;
